import React, { ReactElement, useEffect } from 'react';

import {
  Loader, Text, usePageNumberFromUrl, usePerPageValueFromUrl,
} from 'idsk-react-components';
import { useSearchParams } from 'react-router-dom';
import { MobilePerPageSelect, Pagination, useResponsiveContext } from 'slovlex-idsk-react-components';
import FilterInput from '../../../FilterInput';
import routes from '../../../../routing/routes';
import UlohyOrganizacieList from './component/UlohyOrganizacieList';
import getPaginationTotalLabel from '../../../../function/getPaginationTotalLabel';
import { defaultPerPageValue, perPageDataArray } from '../../../../constants/PaginationPerPageConstants';
import useUlohyOrganizacie from './hooks/useUlohyOrganizacie';
import './ulohyOrganizacie.scss';

interface Props {
  setPageStatus?: (status: number) => void;
}

const UlohyOrganizacie = ({ setPageStatus }: Props): ReactElement => {
  const { page } = usePageNumberFromUrl('page');
  const { perPageValue } = usePerPageValueFromUrl('perPage', perPageDataArray, defaultPerPageValue);
  const [searchParams, setSearchParams] = useSearchParams();
  const { ulohyOrganizacie, ulohyOrganizacieStatus, searchText } = useUlohyOrganizacie();
  const { isSmallScreen } = useResponsiveContext();

  useEffect(() => {
    setPageStatus(ulohyOrganizacieStatus.responseCode);
  }, [ulohyOrganizacieStatus.responseCode, setPageStatus]);

  if (!ulohyOrganizacie) {
    return <Loader loading={ulohyOrganizacieStatus.loading} />;
  }

  if (!ulohyOrganizacie.ulohyOrganizacie || ulohyOrganizacie.ulohyOrganizacie.length === 0) {
    return (
      <>
        <FilterInput filterParam={searchText} label="Zadajte hľadané meno" route={routes.ulohyOrganizacie.list} />
        <Loader loading={ulohyOrganizacieStatus.loading}>
          <Text type="p" size="l" className="text-center">
            Nenašli sa žiadne záznamy.
          </Text>
        </Loader>
      </>
    );
  }

  return (
    <div className="ulohy-organizacie-list">
      <FilterInput filterParam={searchText} label="Zadajte hľadané meno" route={routes.ulohyOrganizacie.list} />
      <Loader loading={ulohyOrganizacieStatus.loading}>
        <>
          {isSmallScreen ? (
            <div className="per-page-select">
              <MobilePerPageSelect
                onRecordsPerPageChange={(value) => {
                  const updatedSearchParams = new URLSearchParams(searchParams.toString());
                  updatedSearchParams.set('perPage', value.toString());
                  setSearchParams(updatedSearchParams.toString());
                }}
                recordsPerPage={perPageDataArray}
                perPageValue={perPageValue}
                totalText={getPaginationTotalLabel(ulohyOrganizacie, page, 'Zamestnanci organizácie')}
              />
            </div>
          ) : (
            <Text className="pagination-total-label">
              {getPaginationTotalLabel(ulohyOrganizacie, page, 'Zamestnanci organizácie')}
            </Text>
          )}
          <UlohyOrganizacieList ulohyOrganizacie={ulohyOrganizacie} />
          <div className="ulohy-organizacie-list-pagination-row">
            <Pagination
              hideTotal
              number={page}
              size={ulohyOrganizacie.size}
              totalElements={ulohyOrganizacie.totalElements}
              onRecordsPerPageChange={(value) => {
                const updatedSearchParams = new URLSearchParams(searchParams.toString());
                updatedSearchParams.set('perPage', value.toString());
                setSearchParams(updatedSearchParams.toString());
              }}
              recordsPerPage={perPageDataArray}
              perPageValue={perPageValue}
            />
          </div>
        </>
      </Loader>
    </div>
  );
};

export default UlohyOrganizacie;
